import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import useMobile from "../../../../../hooks/useMobile";
import { useOnClickOutside } from "components/hooks";
import { useSelector } from "react-redux";
import { ChevronDown } from "../../../../../components/icons";
import { BackIcon } from "../../../../builder/screens/visual/EditorMenu/ThemeSettings";
import { DOCS_MENU_ITEMS } from "../constants";

import "./index.scss";


const MobileNav = ({ selectedItem }) => {

	const { pathname } = useLocation();
	const isMobile = useMobile();
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);

	let dropdownRef = useRef();

	let [buttonDropdown, setButtonDropdown] = useState(false);

	let closeDropdownMenu = () => setButtonDropdown(false);
	let toggleDropdownMenu = () => setButtonDropdown(!buttonDropdown);

	useOnClickOutside(dropdownRef, closeDropdownMenu);

	useEffect(() => {
		closeDropdownMenu();
	}, [pathname]);

	let current = DOCS_MENU_ITEMS.find(({ value }) => value === selectedItem)

	if(!isMobile) {
		return null
	}

	return <div className={`docs-mobile-nav ${buttonDropdown ? 'open' : ''}`} ref={dropdownRef}>

		<div className="docs-mobile-nav-current" onClick={toggleDropdownMenu}>
			{buttonDropdown ? <div className="docs-mobile-nav-back"><BackIcon /></div> : null}
			<div className={buttonDropdown ? "w-100 text-center" : ""} style={buttonDropdown ? { paddingRight: "2.25rem" } : {}}>{current?.icon} {current?.label}</div>
			{buttonDropdown ? null : <div className="docs-mobile-nav-back"><ChevronDown /></div>}
		</div>

		<div className={`docs-mobile-nav-body ${buttonDropdown ? 'd-flex' : 'd-none'}`} style={{ height: `calc(100% - ${bannerHeight}px - 3rem - 1rem)`}}>

			<div className="docs-mobile-nav-list">
				<div className="docs-mobile-nav-list-body">
					{DOCS_MENU_ITEMS.map(({ label, value, type, icon }) => (
						<Link onClick={closeDropdownMenu} replace to={`${pathname}?section=${value}`} key={value} className={value === selectedItem ? 'active' : ''} style={{ marginLeft: type === 'sub' ? '2rem' : type === 'sub' ? '4rem' : '0' }}>
							{icon}
							<span>{label}</span>
						</Link>
					))}
				</div>
			</div>

		</div>

	</div>
}


export default MobileNav;
